module.exports = [
  'upper',
  'upperCase',
  'ucFirst',
  'upperCaseFirst',
  'lcFirst',
  'lowerCaseFirst',
  'lower',
  'lowerCase',
  'sentence',
  'sentenceCase',
  'title',
  'titleCase',
  'camel',
  'camelCase',
  'pascal',
  'pascalCase',
  'snake',
  'snakeCase',
  'param',
  'paramCase',
  'dot',
  'dotCase',
  'path',
  'pathCase',
  'constant',
  'constantCase',
  'swap',
  'swapCase'
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/change-object-case/transformations.js
 ** module id = 681
 ** module chunks = 0
 **/